<template>
  <div class="addon-lists mt-5" v-if="package.addons?.length > 0">
    <h2
      class="selected-title text-secondary"
      v-if="
        subscriptionStore.selectedAddons.filter(
          addon => addon?.lifeAlreadyPaid !== true,
        ).length > 0 || !notDisplayLifeAddonsAlreadyPaid
      "
    >
      Option <span class="text-caption">(facultatif)</span>
    </h2>

    <!-- {{ notDisplayLifeAddonsAlreadyPaid }}
    {{ subscriptionStore.selectedAddons.filter(addon => addon?.lifeAlreadyPaid !== true).length }}
    {{ subscriptionStore.selectedAddons.filter(addon => addon.lifeAlreadyPaid == false).length > 0 }}
    {{ notDisplayLifeAddonsAlreadyPaid && subscriptionStore.selectedAddons.filter(addon => addon.lifeAlreadyPaid == false).length > 0 }} -->

    <!-- {{ subscriptionStore.selectedAddons }} -->
    <!-- {{ package.addons }} -->

    <v-row class="addons-list mt-1">
      <v-col
        v-for="addon in package.addons"
        :key="addon.id"
        cols="12"
        :class="{
          'py-0': !showCheckboxes && !isSelected(addon),
          'h-0':
            !(
              (!showCheckboxes && isSelected(addon)) ||
              (showCheckboxes && !isDisabledAndNotDisplay(addon))
            ) ||
            (notDisplayLifeAddonsAlreadyPaid && isDisabled(addon)),
        }"
      >
        <!-- {{ isDisabled(addon) }} -->
        <!-- {{ isDisabledAndNotDisplay(addon) }} -->
        <div
          v-if="
            (!showCheckboxes && isSelected(addon)) ||
            (showCheckboxes && !isDisabledAndNotDisplay(addon))
          "
          class="pa-4 d-flex align-start addon-card border-sm border-opacity-25 rounded-lg ga-3"
          :class="{
            'addon-selected border-secondary':
              isSelected(addon) || isDisabled(addon),
            'border-gray-300': !isSelected(addon),
            'h-0': !showCheckboxes && !isSelected(addon),
            'clickable-addon': showCheckboxes && !isDisabled(addon), // Ajout dynamique du curseur pointeur
          }"
          @click="
            showCheckboxes && !isDisabled(addon) ? toggleAddon(addon) : null
          "
          :style="
            showCheckboxes && !isDisabled(addon)
              ? 'cursor: pointer;'
              : 'cursor: default;'
          "
        >
          <!-- Checkbox -->
          <v-checkbox
            v-if="showCheckboxes && !isDisabled(addon)"
            :model-value="isSelected(addon)"
            @update:model-value="() => toggleAddon(addon)"
            class="pt-1 mr-xs-0 mr-1"
            color="primary"
            :disabled="isDisabled(addon)"
            hide-details
            @click.stop
          />

          <!-- Titre + description -->
          <div class="flex-grow-1 d-flex flex-column justify-content-between">
            <h3 class="font-weight-bold mb-1 text-primary addon-title">
              {{ addon.name }}

              <span>{{
                addon.billing?.includes('life')
                  ? '(A vie)'
                  : addon.billing?.includes('monthly')
                    ? '(Mensuel)'
                    : addon.billing?.includes('annually')
                      ? '(Annuel)'
                      : ''
              }}</span>
            </h3>
            <p class="addon-description mb-0">{{ addon.description }}</p>

            <!-- Prix sur mobile et desktop (mutualisé) -->
            <AddonPrice
              :price="addon.price"
              :priceWithTva="addon.priceWithTva"
              :billing="addon.billing"
              :displayPriceWithTva="displayPriceWithTva"
              :priceClass="'addon-price text-h6 font-weight-bold text-primary text-left d-sm-none d-block d-inline-block'"
            />
          </div>
          <AddonPrice
            :price="addon.price"
            :priceWithTva="addon.priceWithTva"
            :billing="addon.billing"
            :displayPriceWithTva="displayPriceWithTva"
            :priceClass="'addon-price text-h5 font-weight-bold text-primary text-right d-sm-inline-block d-none'"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
/* -------------------------------------------------------------------------- */
/*                                   Props                                    */
/* -------------------------------------------------------------------------- */

import { computed, onMounted, ref, watch } from 'vue'
import { useSubscriptionStore } from '@/store/subscription/subscriptionStore'
import { useUserStore } from '@/store/user/userStore'
import { Package, Addon, Type } from '@/api/subscription-packages/package.d'
import AddonPrice from './AddonPrice.vue'

const props = defineProps<{
  package: Package
  billing?: Type
  showCheckboxes: boolean
  displayPriceWithTva: boolean
  notDisplayLifeAddonsAlreadyPaid?: boolean
}>()
const billing = props.billing ?? 'yearly'
const packageAddons = ref<Addon[]>([])
packageAddons.value = props.package.addons

/* -------------------------------------------------------------------------- */
/*                                 Pinia store                                */
/* -------------------------------------------------------------------------- */
const subscriptionStore = useSubscriptionStore()
const userStore = useUserStore()

/* -------------------------------------------------------------------------- */
/*                               Helper methods                               */
/* -------------------------------------------------------------------------- */

/**
 * Retourne vrai si l'addon est déjà présent dans subscriptionStore.selectedAddons.
 */
function isSelected(addon: Addon) {
  return subscriptionStore.selectedAddons.some(
    entry =>
      typeof entry === 'object' &&
      entry.id === addon.id &&
      entry.billing === addon.billing,
  )

  // const selectedPackageAddons = props.package.addons.map(addon => addon.id);
  // if(selectedPackageAddons.includes(addon.id) && props.package.type == addon.billing) {

  // }
  // else{
  //   removeAddonFromStore(addon.id)
  //   return false
  // }
}

function isDisabled(addon: Addon) {
  const selectedAddon = subscriptionStore.selectedAddons.find(
    entry => entry.id === addon.id && entry.lifeAlreadyPaid == true,
  )
  return selectedAddon ? true : false
}

function isDisabledAndNotDisplay(addon: Addon) {
  const selectedAddon = subscriptionStore.selectedAddons.find(
    entry =>
      entry.id === addon.id &&
      entry.lifeAlreadyPaid == true &&
      !addon.billing.includes('life'),
  )

  return selectedAddon ? true : false
}

function removeAddonFromStore(addonId: string) {
  // const index = subscriptionStore.selectedAddons.findIndex(
  //   entry => typeof entry === 'object' && entry.id === addonId
  // );

  // if (index !== -1) {
  //   subscriptionStore.selectedAddons.splice(index, 1);
  // }

  subscriptionStore.selectedAddons = subscriptionStore.selectedAddons.filter(
    entry => !(typeof entry === 'object' && entry.id === addonId),
  )
}

/**
 * Ajoute ou retire un addon de la liste sélectionnée dans le store.
 */

function toggleAddon(addon: Addon) {
  const index = subscriptionStore.selectedAddons.findIndex(
    entry =>
      typeof entry === 'object' &&
      entry.id === addon.id &&
      entry.billing === addon.billing,
  )

  if (index !== -1) {
    // Supprimer l'addon
    removeAddonFromStore(addon.id)
  } else {
    removeAddonFromStore(addon.id)
    // Ajouter avec billing
    subscriptionStore.selectedAddons.push({
      id: addon.id,
      billing: addon.billing,
      lifeAlreadyPaid: addon.lifeAlreadyPaid,
    })

    // S'assurer que tous les addons (non life et non lifetime) ont les mêmes billings
    if (
      subscriptionStore.currentChangingPlan.type?.includes('life') &&
      addon.billing != 'life' &&
      addon.billing != 'lifetime'
    ) {
      const addonBilling = subscriptionStore.selectedAddons.find(
        entry => typeof entry === 'object' && entry.id === addon.id,
      ).billing

      // Remplacer tous les billings des selected addons par le billing de l'addon n'est pas de billing life ou lifetime
      const selectedAddonsBilling = [...subscriptionStore.selectedAddons]
      selectedAddonsBilling.forEach(selectedAddon => {
        if (
          selectedAddon.billing != 'life' &&
          selectedAddon.billing != 'lifetime'
        ) {
          selectedAddon.billing = addonBilling
          removeAddonFromStore(selectedAddon.id)
          subscriptionStore.selectedAddons.push({
            id: selectedAddon.id,
            billing: addonBilling,
            lifeAlreadyPaid: selectedAddon.lifeAlreadyPaid,
          })
        }
      })
    }
  }
}

watch(
  () => props.package,
  (newPackage, oldPackage) => {
    if (newPackage !== oldPackage) {
      const selectedPackageAddons =
        subscriptionStore.currentChangingPlan?.addons?.map(addon => addon.id)
      const selectedAddonsBilling = [...subscriptionStore.selectedAddons]
      selectedAddonsBilling.forEach(addon => {
        if (selectedPackageAddons) {
          if (
            !selectedPackageAddons?.includes(
              addon.id,
            ) /*|| (selectedPackageAddons.includes(addon.id) && (subscriptionStore.currentChangingPlan.type != addon.billing || addon.billing === 'life' && addon.billing === ''))*/
          ) {
            removeAddonFromStore(addon.id)
          } else {
            if (
              selectedPackageAddons.includes(addon.id) &&
              (subscriptionStore.currentChangingPlan.type != addon.billing ||
                addon.billing === 'life' ||
                addon.billing === 'lifetime' ||
                subscriptionStore.currentChangingPlan.type === 'life')
            ) {
              if (
                addon.billing != 'life' &&
                addon.billing != 'lifetime' &&
                subscriptionStore.currentChangingPlan.type != 'life' &&
                subscriptionStore.currentChangingPlan.type != 'lifetime'
              ) {
                removeAddonFromStore(addon.id)

                // const index = subscriptionStore.selectedAddons.findIndex(
                //   entry => typeof entry === 'object' && entry.id === addon.id && entry.billing === addon.billing
                // );

                // if (index !== -1) {
                subscriptionStore.selectedAddons.push({
                  id: addon.id,
                  billing: subscriptionStore.currentChangingPlan.type,
                  lifeAlreadyPaid: addon.lifeAlreadyPaid,
                })
                // }
              }
            }
          }
        }

        const selectedAddonsBillingIds = subscriptionStore.selectedAddons.map(
          addon => addon.id,
        )

        // userStore.user.addons.forEach(addon => {
        //   if(!selectedAddonsBillingIds?.includes(addon.id) && props.package.addons?.some(a => a.id === addon.id)){
        //     subscriptionStore.selectedAddons.push({
        //       id: addon.id,
        //       billing: addon.billing ?? 'monthly',
        //     });
        //   }
        // })
      })
    }
  },
)

function formatPrice(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
  }).format(amount)
}
</script>

<style scoped>
.addon-card {
  border: 1px solid var(--v-theme-outline-variant);
}
.addon-selected {
  background-color: rgba(var(--v-theme-primary), 0.05);
}
.selected-title {
  font-weight: 700;
  font-size: 1.25rem;
}
.selected-taxe-label {
  font-size: 0.75rem;
  font-weight: 400;
}

.addon-card {
  border: 1px solid #e5e9ec;
}

:deep(.addons-list .v-selection-control) {
  align-items: flex-start;
}

:deep(.addons-list .v-selection-control__input) {
  align-items: flex-start;
}

.addon-price {
  min-width: 140px;
  font-family: 'Poppins', sans-serif;
}

.text-body-2 {
  font-family: 'Poppins', sans-serif;
}

.h-0 {
  height: 0 !important;
  min-height: 0 !important;
  padding: 0px;
  display: none;
}

/* Ajout du curseur pointeur sur la carte cliquable */
.clickable-addon {
  cursor: pointer;
}

.addon-description {
  font-size: 14px;
}

.addon-title {
  font-size: 16px;
}

@media (min-width: 600px) {
  .addon-title {
    font-size: 19px;
  }
}
</style>
